import React, { useState } from "react";

const data = [
  { id: "1", category: "Electronics", attribute: "Brand", value1: "", value2: "" },
  { id: "2", category: "Electronics", attribute: "Warranty", value1: "", value2: "" },
  { id: "3", category: "Clothing", attribute: "Material", value1: "", value2: "" },
];

export default function FilterTable() {
  const [search, setSearch] = useState("");
  const [values, setValues] = useState<{ [key: string]: string[] }>({});

  const handleValueChange = (id: string, index: number, value: string) => {
    setValues((prev) => ({
      ...prev,
      [id]: prev[id] ? prev[id].map((v, i) => (i === index ? value : v)) : ["", ""],
    }));
  };

  return (
    <div className="p-4">
      <input
        type="text"
        className="border p-2 rounded w-full mb-3"
        placeholder="Search Category..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <table className="w-full border">
        <thead>
          <tr className="bg-gray-200">
            <th className="p-2 border">Category</th>
            <th className="p-2 border">Attribute</th>
            <th className="p-2 border">Value 1</th>
            <th className="p-2 border">Value 2</th>
          </tr>
        </thead>
        <tbody>
          {data
            .filter((item) => item.category.toLowerCase().includes(search.toLowerCase()))
            .map((item) => (
              <tr key={item.id}>
                <td className="p-2 border">{item.category}</td>
                <td className="p-2 border">{item.attribute}</td>
                <td className="p-2 border">
                  <input
                    type="text"
                    className="w-full p-1 border rounded"
                    value={values[item.id]?.[0] || ""}
                    onChange={(e) => handleValueChange(item.id, 0, e.target.value)}
                  />
                </td>
                <td className="p-2 border">
                  <input
                    type="text"
                    className="w-full p-1 border rounded"
                    value={values[item.id]?.[1] || ""}
                    onChange={(e) => handleValueChange(item.id, 1, e.target.value)}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
